const constants = {
  NoInternetConnectionHeading: 'No Network',
  NoInternetConnectionText: 'Please check the network and try again.',
  tryAgain: 'Please reconnect and try again.',
  GenericErrorHeading: 'Technical Issues',
  GenericErrorText:
    'There was an issue while loading the content. Please try again.',
  P4bGenericErrorText: 'Oops, something went wrong! Please try again.',
  ErrorBoundaryText: 'Please restart the app and try again.',
  retry: 'Retry',
  removeAppliedCustId: 'Remove applied cust id',
};

export default constants;
